import { Skeleton } from '@heroui/react';

export const ProductName = ({
  text,
  isLoading = false,
}: {
  text: string;
  isLoading?: boolean;
}) => {
  return (
    <Skeleton isLoaded={!isLoading} className="rounded-md">
      <p className="text-sm text-[#222222] break-all h-5 line-clamp-1 overflow-ellipsis">
        {text}
      </p>
    </Skeleton>
  );
};
